// export const url = "https://ct-ems.onrender.com"
// export const url = "https://convertedapi-production.up.railway.app"
export const url = "https://convertedapi.onrender.com"
// export const url = "http://127.0.0.1:5000"
// export const api_url = ""
// export const api_url = "http://127.0.0.1:5000/"